import React, { useState } from 'react';
import { Settings } from 'react-slick';
import dynamic from 'next/dynamic';
import { ImageSliderModal } from '@/components/modals';
import clsx from 'clsx';

const Slider = dynamic(() => import('react-slick'));

interface PropertyImageSliderProps {
  images: string[];
  title?: string;
  blurContent?: boolean;
}

const SliderImage = ({ img, onClick, blurContent }) => {
  const [error, setError] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const src: any = error ? '/img/logo.png' : img;
  return (
    <div
      className="h-52 w-full mr-5 relative overflow-hidden flex items-center justify-center"
      onClick={onClick}
    >
      <div className="h-52 w-full flex items-center justify-center p-2 rounded-md">
        {blurContent && (
          <div className="border-2 border-transparent bg-gray-200 cursor-pointer z-20 rounded-md h-full object-cover w-full" />
        )}
        {!blurContent && (
          <img
            src={src}
            className="bg-gray-50 border-2 border-transparent  cursor-pointer z-20 rounded-md h-full object-cover w-full"
            alt="Slider Image"
            onError={() => setError(true)}
          />
        )}
      </div>
    </div>
  );
};

export function PropertyImageSlider({
  images,
  title,
  blurContent,
}: PropertyImageSliderProps) {
  const [open, setOpen] = useState(null);

  const settings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: !blurContent,
    autoplay: false,
    pauseOnHover: true,
    autoplaySpeed: 5000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className={clsx('h-52 mb-8', blurContent && 'blur-sm')}>
      <div className="mx-5">
        <Slider {...settings}>
          {images.map((img, index) => (
            <SliderImage
              img={img + '?class=small'}
              onClick={() => !blurContent && setOpen(index)}
              key={String(index)}
              blurContent={blurContent}
            />
          ))}
        </Slider>
      </div>

      <ImageSliderModal
        open={open !== null}
        toggleModal={() => setOpen(null)}
        images={images}
        initialSelected={open}
        title={title}
      />
    </div>
  );
}
